import { render, staticRenderFns } from "./OrganizationTypeSelect.vue?vue&type=template&id=0d882508"
import script from "./OrganizationTypeSelect.ts?vue&type=script&lang=ts&external"
export * from "./OrganizationTypeSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports